// Same thousands separator as the Rails locales: a narrow no-break space, per SI / ISO 80000.
// Chart.js and other browser formatting would otherwise follow the visitor's browser language.
export function formatNumber(value, decimals) {
  const digits = decimals === undefined ? {} : { minimumFractionDigits: decimals, maximumFractionDigits: decimals }
  return new Intl.NumberFormat("en-US", digits).format(value).replaceAll(",", " ")
}
